<template>
  <div>
    <div class="mypage__main" v-show="step === 0">
      <h2 class="mypage__h2 sub_header_title">
        お届け先情報の変更
      </h2>

      <div class="flex-center" v-show="isLoading">
        <Loading :active.sync="isLoading" :is-full-page="true" loader="dots" :height="20"></Loading>
        <p class="loading-txt">このまましばらくお待ちください。</p>
      </div>

      <div :class="[selectedCustomerId ? 'addressList addressList__overlay' : 'addressList']">
        <div class="addressList__row" v-for="customer in allCustomers" :key="customer.customerId">
          <h3 class="addressList__name">{{ customer.name.firstName }}{{ customer.name.lastName }}</h3>
          <dl class="addressList__info">
            <dt>会社名/団体名</dt>
            <dd>{{ customer.company || "-" }}</dd>
            <dt>郵便番号</dt>
            <dd>{{ customer.postalCode.first }}-{{ customer.postalCode.second }}</dd>
            <dt>住所</dt>
            <dd>{{ customer.address || "-" }}</dd>
            <dt>電話番号</dt>
            <dd>{{ customer.tel.first }}-{{ customer.tel.second }}-{{ customer.tel.third }}</dd>
          </dl>
          <div class="addressList__buttons">
            <div>
              <div class="enter__btn enter__btn__pink text-center">
                <button @click.stop.prevent="editHandler(customer)">
                  変更する
                </button>
              </div>
              <button class="delete__btn" v-on:click.stop="selectCustomer(customer.customerId)">
                × 削除する
              </button>
            </div>
          </div>

          <div
            v-click-outside="selectCustomerInit"
            class="addressList__deleteBox"
            v-if="selectedCustomerId === customer.customerId"
          >
            <div>
              <p>このお届け先を削除してよろしいですか？</p>
              <ul class="addressList__delete__buttons">
                <li>
                  <button @click="selectCustomer(customer.customerId)">
                    いいえ
                  </button>
                </li>
                <li>
                  <button @click="deleteCustomer(customer.customerId)">
                    はい
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="enter__btn enter__btn__pink text-center">
        <button @click="setStep(3)">お届け先を追加する</button>
      </div>
    </div>

    <div class="mypage__main" v-show="step === 1">
      <h2 class="mypage__h2">お届け先情報の変更</h2>
      <div class="mypage__contents">
        <h3 class="mypage__h3">
          お届け先情報を変更
        </h3>

        <div action="post" v-if="editItem">
          <validation-observer class="h-adr" tag="form" v-slot="{ invalid, errors }">
            <span class="p-country-name" style="display:none;">Japan</span>
            <div class="enter-form">
              <dl class="enter-form__items">
                <div class="enter-form__item">
                  <dt class="-required">お名前</dt>
                  <dd class="name">
                    <span>姓</span>
                    <ValidationProvider rules="required" vid="form1" class="val-mypage" name="姓">
                      <input type="text" v-model="editItem.name.firstName" />
                    </ValidationProvider>
                    <span>名</span>
                    <ValidationProvider rules="required" vid="form2" class="val-mypage" name="名">
                      <input type="text" v-model="editItem.name.lastName" />
                    </ValidationProvider>
                  </dd>
                </div>
                <span class="address_error" v-if="errors.form1">{{ errors.form1[0] }} </span>
                <span class="address_error" v-if="errors.form2">{{ errors.form2[0] }} </span>
                <div class="enter-form__item">
                  <dt>会社名</dt>
                  <dd>
                    <input type="text" v-model="editItem.company" />
                  </dd>
                </div>
                <div class="enter-form__item">
                  <dt class="-required">郵便番号</dt>
                  <dd class="postalcode">
                    <ValidationProvider
                      rules="required|max:4|numeric"
                      vid="postal_code1"
                      class="val-mypage"
                      name="郵便番号1"
                    >
                      <input type="text" maxlength="4" class="p-postal-code" v-model="editItem.postalCode.first" />
                    </ValidationProvider>
                    <span>-</span>
                    <ValidationProvider
                      rules="required|max:4|numeric"
                      vid="postal_code2"
                      class="val-mypage"
                      name="郵便番号2"
                    >
                      <input maxlength="4" type="text" class="p-postal-code" v-model="editItem.postalCode.second"
                    /></ValidationProvider>
                  </dd>
                </div>
                <span class="address_error" v-if="errors.postal_code1">{{ errors.postal_code1[0] }} </span>
                <span class="address_error" v-if="errors.postal_code2">{{ errors.postal_code2[0] }} </span>
                <div class="enter-form__item">
                  <dt class="-required">住所</dt>
                  <dd>
                    <div class="new_address_val">
                      <dd class="new_dd_address pref">
                        <ValidationProvider
                          rules="required"
                          vid="prefecture"
                          class="val-mypage add_add_address"
                          name="都道府県"
                        >
                          <input
                            ref="focus_prefecture"
                            readonly
                            type="text"
                            placeholder="都道府県"
                            v-model="editItem.prefecture"
                          />
                        </ValidationProvider>
                      </dd>

                      <dd class="new_dd_address">
                        <ValidationProvider
                          rules="required"
                          vid="address"
                          class="val-mypage add_add_address"
                          name="市区町村"
                        >
                          <input
                            ref="focus_pre_address"
                            readonly
                            type="text"
                            placeholder="市区町村"
                            v-model="editItem.pre_address"
                        /></ValidationProvider>
                      </dd>

                      <dd class="new_dd_address">
                        <ValidationProvider
                          rules="required"
                          vid="detail_address"
                          class="val-mypage add_add_address"
                          name="番地、建物名、部屋番号"
                        >
                          <input type="text" placeholder="番地、建物名、部屋番号" v-model="editItem.detail_address"
                        /></ValidationProvider>
                      </dd>
                    </div>
                  </dd>
                </div>
                <span v-if="is_postal_error !== ''" class="address_error">
                  {{ is_postal_error }}
                </span>
                <span class="address_error" v-if="errors.detail_address">{{ errors.detail_address[0] }} </span>
                <div class="enter-form__item">
                  <dt class="-required">電話番号</dt>
                  <dd class="tel">
                    <ValidationProvider rules="required|numeric" vid="tel1" name="電話番号1" class="val-mypage">
                      <input type="text" maxlength="5" v-model="editItem.tel.first"
                    /></ValidationProvider>
                    <span>-</span>
                    <ValidationProvider rules="required|numeric" vid="tel2" name="電話番号2" class="val-mypage">
                      <input type="text" maxlength="4" v-model="editItem.tel.second"
                    /></ValidationProvider>
                    <span>-</span>
                    <ValidationProvider rules="required|numeric" vid="tel3" name="電話番号3" class="val-mypage">
                      <input type="text" maxlength="4" v-model="editItem.tel.third"
                    /></ValidationProvider>
                  </dd>
                </div>
                <span class="address_error" v-if="errors.tel1">{{ errors.tel1[0] }} </span>
                <span class="address_error" v-if="errors.tel2">{{ errors.tel2[0] }} </span>
                <span class="address_error" v-if="errors.tel3">{{ errors.tel3[0] }} </span>
              </dl>
            </div>

            <ul class="confirm__buttons">
              <li class="enter__btn enter__btn__white">
                <button type="button" @click="setStep(0)">
                  お届け先情報一覧へ戻る
                </button>
              </li>
              <li class="enter__btn enter__btn__pink">
                <button
                  type="button"
                  @click="setStep(2)"
                  :disabled="invalid || is_postal_error !== ''"
                  :class="invalid || is_postal_error !== '' ? 'disabled_btn' : ''"
                >
                  確認する
                </button>
              </li>
            </ul>
          </validation-observer>
        </div>
      </div>
    </div>

    <!-- 新しいお届け先情報を追加 -->
    <div class="mypage__main" v-show="step === 3">
      <h2 class="mypage__h2">お届け先情報の変更</h2>
      <div class="mypage__contents">
        <h3 class="mypage__h3">
          新しいお届け先情報を追加
        </h3>

        <div action="post" v-if="newCustomerInfo">
          <validation-observer class="h-adr" tag="form" v-slot="{ errors, passes }">
            <form @submit.prevent="passes(newCustomerAddConfirm)">
              <span class="p-country-name" style="display:none;">Japan</span>
              <div class="enter-form">
                <dl class="enter-form__items">
                  <div class="enter-form__item">
                    <dt class="-required">お名前</dt>
                    <dd class="name">
                      <span>姓</span>
                      <ValidationProvider rules="required" vid="form1" class="val-mypage" name="姓">
                        <input name="name_firstName" type="text" v-model="newCustomerInfo.name.firstName" />
                      </ValidationProvider>
                      <span>名</span>
                      <ValidationProvider rules="required" vid="form2" class="val-mypage" name="名">
                        <input name="name_lastName" type="text" v-model="newCustomerInfo.name.lastName" />
                      </ValidationProvider>
                    </dd>
                  </div>
                  <span class="address_error" v-if="errors.form1">{{ errors.form1[0] }} </span>
                  <span class="address_error" v-if="errors.form2">{{ errors.form2[0] }} </span>
                  <div class="enter-form__item">
                    <dt>会社名</dt>
                    <dd>
                      <input name="company" type="text" v-model="newCustomerInfo.company" />
                    </dd>
                  </div>
                  <div class="enter-form__item">
                    <dt class="-required">郵便番号</dt>
                    <dd class="postalcode">
                      <ValidationProvider
                        rules="required|max:4|numeric"
                        vid="postal_code1"
                        class="val-mypage"
                        name="郵便番号1"
                      >
                        <input
                          name="postalCode_first"
                          type="text"
                          maxlength="4"
                          class="p-postal-code"
                          v-model="newCustomerInfo.postalCode.first"
                        />
                      </ValidationProvider>
                      <span>-</span>
                      <ValidationProvider
                        rules="required|max:4|numeric"
                        vid="postal_code2"
                        class="val-mypage"
                        name="郵便番号2"
                      >
                        <input
                          name="postalCode_second"
                          maxlength="4"
                          type="text"
                          class="p-postal-code"
                          v-model="newCustomerInfo.postalCode.second"
                      /></ValidationProvider>
                    </dd>
                  </div>
                  <span class="address_error" v-if="errors.postal_code1">{{ errors.postal_code1[0] }} </span>
                  <span class="address_error" v-if="errors.postal_code2">{{ errors.postal_code2[0] }} </span>
                  <div class="enter-form__item">
                    <dt class="-required">住所</dt>
                    <dd>
                      <div class="new_address_val">
                        <dd class="new_dd_address pref">
                          <ValidationProvider
                            rules="required"
                            vid="prefecture"
                            class="val-mypage add_add_address"
                            name="都道府県"
                          >
                            <input
                              name="prefecture"
                              class="p-region"
                              ref="focus_prefecture"
                              readonly
                              type="text"
                              placeholder="都道府県"
                              v-model="newCustomerInfo.prefecture"
                            />
                          </ValidationProvider>
                        </dd>

                        <dd class="new_dd_address">
                          <ValidationProvider
                            rules="required"
                            vid="pre_address"
                            class="val-mypage add_add_address"
                            name="市区町村"
                          >
                            <input
                              name="pre_address"
                              class="p-locality"
                              ref="focus_pre_address"
                              readonly
                              type="text"
                              placeholder="市区町村"
                              v-model="newCustomerInfo.pre_address"
                          /></ValidationProvider>
                        </dd>

                        <dd class="new_dd_address">
                          <ValidationProvider
                            rules="required"
                            vid="detail_address"
                            class="val-mypage add_add_address"
                            name="番地、建物名、部屋番号"
                          >
                            <input
                              name="detail_address"
                              type="text"
                              placeholder="番地、建物名、部屋番号"
                              v-model="newCustomerInfo.detail_address"
                          /></ValidationProvider>
                        </dd>
                      </div>
                    </dd>
                  </div>
                  <span v-if="is_postal_error !== ''" class="address_error">
                    {{ is_postal_error }}
                  </span>
                  <span class="address_error" v-if="errors.prefecture">{{ errors.prefecture[0] }} </span>
                  <span class="address_error" v-if="errors.pre_address">{{ errors.pre_address[0] }} </span>
                  <span class="address_error" v-if="errors.detail_address">{{ errors.detail_address[0] }} </span>
                  <div class="enter-form__item">
                    <dt class="-required">電話番号</dt>
                    <dd class="tel">
                      <ValidationProvider rules="required|numeric" vid="tel1" name="電話番号1" class="val-mypage">
                        <input
                          name="tel_first"
                          type="text"
                          minlength="2"
                          maxlength="5"
                          v-model="newCustomerInfo.tel.first"
                      /></ValidationProvider>
                      <span>-</span>
                      <ValidationProvider rules="required|numeric" vid="tel2" name="電話番号2" class="val-mypage">
                        <input
                          name="tel_second"
                          type="text"
                          minlength="1"
                          maxlength="4"
                          v-model="newCustomerInfo.tel.second"
                      /></ValidationProvider>
                      <span>-</span>
                      <ValidationProvider rules="required|numeric" vid="tel3" name="電話番号3" class="val-mypage">
                        <input
                          name="tel_third"
                          type="text"
                          minlength="4"
                          maxlength="4"
                          v-model="newCustomerInfo.tel.third"
                      /></ValidationProvider>
                    </dd>
                  </div>
                  <span class="address_error" v-if="errors.tel1">{{ errors.tel1[0] }} </span>
                  <span class="address_error" v-if="errors.tel2">{{ errors.tel2[0] }} </span>
                  <span class="address_error" v-if="errors.tel3">{{ errors.tel3[0] }} </span>
                </dl>
              </div>

              <ul class="confirm__buttons">
                <li class="enter__btn enter__btn__white">
                  <button type="button" @click="setStep(0)">
                    お届け先情報一覧へ戻る
                  </button>
                </li>
                <li class="enter__btn enter__btn__pink">
                  <button type="submit" name="confirm">
                    確認する
                  </button>
                </li>
              </ul>
            </form>
          </validation-observer>
        </div>
      </div>
    </div>

    <!-- 新しいお届け先情報を確認 -->
    <div class="mypage__main" v-show="step === 4">
      <h2 class="mypage__h2">お届け先情報の変更</h2>
      <div class="mypage__contents">
        <h3 class="mypage__h3">新しいお届け先情報を確認</h3>
        <div class="confirm__item">
          <div action="post" v-if="newCustomerInfo">
            <div class="enter-form confirm">
              <dl class="confirm__detail">
                <div class="confirm__data">
                  <dt class="-required">お名前</dt>
                  <dd class="name">
                    <span>{{ newCustomerInfo.name.firstName }}</span>
                    <span>{{ newCustomerInfo.name.lastName }}</span>
                  </dd>
                </div>
                <div class="confirm__data">
                  <dt>会社名</dt>
                  <dd>
                    {{ newCustomerInfo.company || "-" }}
                  </dd>
                </div>
                <div class="confirm__data">
                  <dt class="-required">郵便番号</dt>
                  <dd class="postalcode">
                    {{ newCustomerInfo.postalCode.first }}-{{ newCustomerInfo.postalCode.second }}
                  </dd>
                </div>
                <div class="confirm__data">
                  <dt class="-required">住所</dt>
                  <dd>
                    {{
                      newCustomerInfo.prefecture + newCustomerInfo.pre_address + " " + newCustomerInfo.detail_address
                    }}
                  </dd>
                </div>
                <div class="confirm__data">
                  <dt class="-required">電話番号</dt>
                  <dd class="tel">
                    {{ newCustomerInfo.tel.first }}-{{ newCustomerInfo.tel.second }}-{{ newCustomerInfo.tel.third }}
                  </dd>
                </div>
              </dl>
            </div>
            <ul class="confirm__buttons">
              <li class="enter__btn enter__btn__white">
                <button type="button" @click="setStep(3)">
                  お届け先入力へ戻る
                </button>
              </li>
              <li class="enter__btn enter__btn__pink">
                <button type="button" name="new_address_submit" @click="addCustomer()">
                  上記のお届け先を登録する
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 確認画面 -->
    <div class="mypage__main" v-show="step === 2">
      <h2 class="mypage__h2">お届け先情報の変更</h2>
      <div class="mypage__contents">
        <h3 class="mypage__h3">お届け先情報を確認</h3>
        <div class="confirm__item">
          <div action="post" v-if="editItem">
            <div class="enter-form confirm">
              <dl class="confirm__detail">
                <div class="confirm__data">
                  <dt class="-required">お名前</dt>
                  <dd class="name">
                    <span>{{ editItem.name.firstName }}</span>
                    <span>{{ editItem.name.lastName }}</span>
                  </dd>
                </div>
                <div class="confirm__data">
                  <dt>会社名</dt>
                  <dd>
                    {{ editItem.company || "-" }}
                  </dd>
                </div>
                <div class="confirm__data">
                  <dt class="-required">郵便番号</dt>
                  <dd class="postalcode">{{ editItem.postalCode.first }}-{{ editItem.postalCode.second }}</dd>
                </div>
                <div class="confirm__data">
                  <dt class="-required">住所</dt>
                  <dd>
                    {{
                      editItem.detail_address
                        ? editItem.prefecture + editItem.pre_address + " " + editItem.detail_address
                        : editItem.address
                    }}
                  </dd>
                </div>
                <div class="confirm__data">
                  <dt class="-required">電話番号</dt>
                  <dd class="tel">{{ editItem.tel.first }}-{{ editItem.tel.second }}-{{ editItem.tel.third }}</dd>
                </div>
              </dl>
            </div>
            <ul class="confirm__buttons">
              <li class="enter__btn enter__btn__white">
                <button type="button" @click="setStep(1)">
                  お届け先入力へ戻る
                </button>
              </li>
              <li class="enter__btn enter__btn__pink">
                <button type="button" @click="updateCustomer()">
                  上記のお届け先を登録する
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import { mapGetters, mapActions } from "vuex";
import Api from "../base/api";
import ClickOutside from "vue-click-outside";
import { Core as YubinBangoCore } from "yubinbango-core2";
import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email, max, max_value, numeric } from "vee-validate/dist/rules";
import { PostalFunc } from "../base/postal";

extend("max", max);
extend("max_value", max_value);
extend("numeric", {
  ...numeric,
  message: "{_field_}は半角数字で入力してください"
});
extend("email", {
  ...email,
  message: "メールアドレスの形式ではありません"
});
extend("required", {
  ...required,
  message: "{_field_}は必須項目です"
});

export default {
  name: "cAddress",
  data() {
    return {
      isUpdateLoading: false,
      isCreateLoading: false,
      isUpdate: false,
      userID: null,
      allCustomers: null,
      updateCustomerId: null,
      newCustomerInfo: {
        name: { firstName: "", lastName: "" },
        company: "",
        postalCode: {
          first: "",
          second: ""
        },
        prefecture: "",
        pre_address: "",
        detail_address: "",
        tel: {
          first: "",
          second: "",
          third: ""
        }
      },
      editItem: {
        name: { firstName: "", lastName: "" },
        company: "",
        postalCode: {
          first: "",
          second: ""
        },
        prefecture: "",
        pre_address: "",
        detail_address: "",
        tel: {
          first: "",
          second: "",
          third: ""
        }
      },
      is_postal_error: "",
      selectedCustomerId: null
    };
  },
  components: {
    Loading,
    ValidationProvider,
    ValidationObserver
  },
  computed: {
    ...mapGetters({
      customerId: "getCustomerId",
      cardPlaceholder: "getCardPlaceholder",
      isLoading: "getLoading",
      allCards: "getAllCards",
      step: "getStep"
    })
  },
  async mounted() {
    this.userID = WP_API_Settings.userID;
    this.listCustomer();
  },
  directives: {
    ClickOutside
  },
  watch: {
    "editItem.postalCode": {
      handler: function() {
        if (!this.editItem) {
        } else {
          let val = this.editItem.postalCode.first + this.editItem.postalCode.second;
          this.createAddress(val, true);
        }
      },
      deep: true
    },
    "newCustomerInfo.postalCode": {
      handler: function() {
        if (!this.newCustomerInfo) {
        } else {
          let val = this.newCustomerInfo.postalCode.first + this.newCustomerInfo.postalCode.second;
          this.createAddress(val, false);
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(["setCardPlaceholder", "setCustomerId", "setLoading", "setAllCards", "setStep"]),
    editHandler(item) {
      this.editItem = JSON.parse(JSON.stringify(item));
      this.isUpdate = true;
      this.setStep(1);
    },
    async createAddress(ch, isedit) {
      //郵便番号自動入力
      try {
        new YubinBangoCore(ch, (addr) => {
          if (addr?.region_id) {
            if (isedit) {
              this.$set(this.editItem, "prefecture", addr.region);
              this.$set(this.editItem, "pre_address", addr.locality + addr.street);
            } else {
              this.$set(this.newCustomerInfo, "prefecture", addr.region);

              this.$set(this.newCustomerInfo, "pre_address", addr.locality + addr.street);
            }

            this.is_postal_error = "";
          } else {
            this.is_postal_error = "この郵便番号は存在しません。";
            if (isedit) {
              this.$set(this.editItem, "prefecture", "");
              this.$set(this.editItem, "pre_address", "");
            } else {
              this.$set(this.newCustomerInfo, "prefecture", "");
              this.$set(this.newCustomerInfo, "pre_address", "");
            }
          }
        });
      } catch (error) {
        this.is_postal_error = "この郵便番号は存在しません。";
        cnsole.log(error);
        if (isedit) {
          this.$set(this.editItem, "prefecture", "");
          this.$set(this.editItem, "pre_address", "");
        } else {
          this.$set(this.newCustomerInfo, "prefecture", "");
          this.$set(this.newCustomerInfo, "pre_address", "");
        }
      }
    },
    async newCustomerAddConfirm() {
      this.setStep(4);
    },
    selectCustomer(customermId) {
      if (this.selectedCustomerId === customermId) {
        this.selectedCustomerId = null;
      } else this.selectedCustomerId = customermId;
    },
    selectCustomerInit() {
      this.selectedCustomerId = null;
    },

    async updateCustomer() {
      this.isUpdateLoading = true;
      console.log(this.editItem);
      const setUpdateData = this.allCustomers
        ? [
            ...this.allCustomers.map((item, index) => {
              if (this.editItem.customerId === item.customerId) {
                return {
                  ...item,
                  ...this.editItem
                };
              } else {
                return item;
              }
            })
          ]
        : [];

      try {
        await Api.post(`/index.php/wp-json/custom/v1/addressees/edit/${this.userID}`, {
          data: JSON.stringify(setUpdateData)
        });
        this.setStep(0);
        await this.listCustomer();
        this.isUpdateLoading = false;
      } catch (error) {
        console.log("update customer error", error);
      }
    },

    async addCustomer() {
      this.isCreateLoading = true;
      try {
        const setAddData = this.allCustomers ? [this.newCustomerInfo, ...this.allCustomers] : [this.newCustomerInfo];
        const { data } = await Api.post(`/index.php/wp-json/custom/v1/addressees/add/${this.userID}`, {
          data: JSON.stringify(setAddData)
        });

        await this.listCustomer();
        this.setStep(0);
        this.newCustomerInfo = {
          name: { firstName: "", lastName: "" },
          company: "",
          postalCode: {
            first: "",
            second: ""
          },
          prefecture: "",
          pre_address: "",
          detail_address: "",
          tel: {
            first: "",
            second: "",
            third: ""
          }
        };

        this.isCreateLoading = false;
      } catch (error) {
        console.log("add customer error", error);
      }
    },
    async deleteCustomer(customerId) {
      try {
        const { data } = await Api.post(`/index.php/wp-json/custom/v1/addressees/delete/${this.userID}`, {
          delete_id: customerId
        });

        window.location.reload();
      } catch (error) {
        console.log("error1", error);
      }
    },
    JoinNumber(num1, num2, num3, isFormat) {
      //郵便、電話番号結合
      if (num3) return [num1, num2, num3].join("-");
      //tel
      else {
        if (isFormat) return [num1, num2].join("-");
        //postal code}
        else return [num1, num2].join("");
      }
    },
    async calcPos(postalCode) {
      const postalMap = await PostalFunc(postalCode);
      const { full } = postalMap;
      return full;
    },
    async listCustomer() {
      try {
        const { data } = await Api.get(`/index.php/wp-json/custom/v1/users/${this.userID}`, {});

        const formtatedR = await Promise.all(
          data.registered.map(async (item) => {
            const prefecture = item.prefecture;
            const pre_address = item.pre_address;
            const postalCode = item.postalCode;
            if (prefecture && pre_address) {
              // prefectureとpre_addressがあればそれを用いる
              return {
                ...item,
                address: prefecture + pre_address + " " + (item.detail_address ? item.detail_address : "-")
              };
            } else {
              const fullAddress = await this.calcPos(this.JoinNumber(postalCode.first, postalCode.second, 0, false));

              return {
                ...item,
                address: `${fullAddress ? fullAddress : "-"} ` + (item.detail_address ? item.detail_address : "-")
              };
            }
          })
        );

        this.allCustomers = formtatedR;
        this.setLoading(false);
        console.log(this.allCustomers);
      } catch (error) {
        console.log("list error", error);
        throw new Error(error);
      }
    }
  }
};
</script>
